module.exports = __webpack_public_path__ + "img/bgStem@2x.cd6ba0bc.jpg";